import { cn } from '@/utils/cn';

interface TicketCuticleDotProps {
  isVertical: boolean;
  position: 'start' | 'end';
  className?: string;
}

const TicketCuticleDot = ({
  isVertical,
  position,
  className,
}: TicketCuticleDotProps) => {
  const shapeClasses = isVertical
    ? position === 'start'
      ? 'h-3 w-6 rounded-b-full border-b border-l border-r'
      : 'h-3 w-6 rounded-t-full border-l border-r border-t'
    : position === 'start'
      ? 'h-6 w-3 rounded-r-full border-b border-r border-t'
      : 'h-6 w-3 rounded-l-full border-b border-l border-t';

  return (
    <div
      className={cn(
        shapeClasses,
        'shrink-0 border-neutral-light bg-background',
        className
      )}
    />
  );
};

export default TicketCuticleDot;
